import { notification } from 'antd';

export default function showNotification(type, { message, description}) {
    notification[type]({
        message: message,
        description: description,
    });
};